import React from "react";
import { MenuItem } from "@mui/material";
import { CombinedMilestoneData } from "../types";
import { getMilestoneId, isMilestoneNotApplicable, areAllTasksDisabled } from "../utils/milestoneUtils";
import MilestoneMenuBase from "./MilestoneMenuBase";

interface MilestoneMenuProps {
     anchorEl: null | HTMLElement;
     handleClose: () => void;
     handleNotApplicableMilestone: () => void;
     isNotApplicableMilestone: (milestoneName: string) => boolean;
     selectedMilestoneId: string | null;
     milestone: CombinedMilestoneData;
}

const MilestoneMenu: React.FC<MilestoneMenuProps> = ({
     anchorEl,
     handleClose,
     handleNotApplicableMilestone,
     isNotApplicableMilestone,
     milestone,
     selectedMilestoneId,
}) => {
     /*
     * Find the current milestone by its ID
     */
     const currentMilestone = milestone?.find((milestoneItem) => {
          const milestoneId = getMilestoneId(milestoneItem);
          return milestoneId === selectedMilestoneId;
     });
     const isCurrentlyNotApplicable = currentMilestone ? isMilestoneNotApplicable(currentMilestone) : false;
     const allTasksDisabled = currentMilestone ? areAllTasksDisabled(currentMilestone) : true;

     // Don't render menu if all tasks are disabled
     if (allTasksDisabled) {
          return null;
     }

     return (
          <MilestoneMenuBase
               key={`menu-${selectedMilestoneId}-${isCurrentlyNotApplicable}`}
               anchorEl={anchorEl}
               isOpen={Boolean(anchorEl)}
               onClose={handleClose}
          >
               <MenuItem onClick={handleNotApplicableMilestone}>
                    {isCurrentlyNotApplicable
                         ? "Set as Applicable"
                         : "Not Applicable"}
               </MenuItem>
          </MilestoneMenuBase>
     );
};

export default MilestoneMenu; 